<template>
  <div
    class="flex size-full flex-col items-stretch overflow-hidden"
  >
    <div
      class="flex shrink-0 border-b bg-gradient-to-r from-primary to-secondary py-2 text-primary-fg"
    >
      <div
        class="mx-auto flex w-full max-w-lg items-center px-2 sm:px-6 lg:px-8"
      >
        <RouterLink :to="{ name: 'home' }">
          <IconBeepaidIconWhite class="size-10" />
        </RouterLink>
        <h1
          class="mx-2 line-clamp-1 grow text-center text-2xl font-medium leading-relaxed"
        >
          {{
            route.name === "home"
              ? currentTenant?.name
              : pageTitle
          }}
        </h1>

        <BaseNavigation class="w-10" />
      </div>
    </div>
    <main
      class="mx-auto flex size-full flex-col overflow-hidden sm:max-w-lg sm:p-4"
    >
      <RouterView #default="{ Component: component }">
        <Transition
          enter-active-class="transition-opacity duration-150"
          enter-from-class="opacity-0"
          leave-active-class="transition-opacity duration-100"
          leave-to-class="opacity-0"
          mode="out-in"
        >
          <BaseCard
            :key="route.path"
            class="min-h-full overflow-y-auto p-6 sm:min-h-0"
          >
            <Component :is="component" />
          </BaseCard>
        </Transition>
      </RouterView>
    </main>
  </div>
</template>

<script setup lang="ts">
const { currentTenant } = useCurrentTenant()
const { pageTitle } = usePageTitle()
const route = useRoute()
</script>
